import { useEffect, useState } from 'react';
import Modal from '../../Modal';
import { ProposalService } from '../../../services';
import { toast } from 'react-toastify';

interface IProp{
  proposal:any;
  statusActual:any;
}
const Action5 = ({proposal, statusActual}: IProp) => {
    const [payment, setPayment] = useState<any>(); 
    useEffect(() => {
        const getProposalUrlLinkPayment = async () => {
            try {
                const response = await ProposalService.getProposalUrlLinkPayment(proposal.id);
                setPayment(response);
            } catch (error) {
            Modal.show({
                title: "Erro ao gerar link de pagamento",
                body: Modal.getErrorMessage(error, {proposalId: proposal.id}),
                showCancel: true,
                showConfirm: false,
                onCancelText: "Fechar"
            });
            }
        };
        getProposalUrlLinkPayment();
    }, [proposal]);

    function CopyText(text:string){
        navigator.clipboard.writeText(text);
        toast.success("Link Copiado");
    }
    const compartilhar = async (text:string) => {
        if (navigator.share) {
            try {
                await navigator.share({
                title: "Link de Pagamento",
                text: "Efetue o pagamento por este link",
                url: text,
                });
            } catch (err:any) {
                console.error("Erro ao compartilhar:", err);
                toast.error(err);
            }
        } else {
            const mensagem = encodeURIComponent(`Efetue o pagamento do sinal por este link: ${text}`);
            const whatsappUrl = `https://wa.me/?text=${mensagem}`;

            try {
                window.open(whatsappUrl, "_blank");
            } catch (err: any) {
                console.error("Erro ao abrir WhatsApp:", err);
                toast.error("Não foi possível abrir o centro de compartilhamento do dispositivo nem do WhatsApp.");
            }
        }
    };
    return (
        <>
            {
                (proposal.idProposalStatus === statusActual.idProposalStatus) ?
                    <>
                    {
                        (payment?.urlPayment??null) &&
                            <>
                                <p>{proposal.proposalSubStatus?.name??""}</p>
                                {
                                    ((proposal.proposalSubStatus?.name??"") !== "Pago") ?
                                    <>
                                        <p><input type='text' value={payment.urlPayment} className='form-control'/></p>
                                        <button className='btn btn-danger ms-auto btnForm' style={{marginRight:10}} onClick={()=>compartilhar(payment.urlPayment)}>Compartilhar</button>
                                        <button className='btn btn-danger ms-auto' onClick={()=>CopyText(payment.urlPayment)}>Copiar Link</button>
                                    </>
                                    :<>Pagamento em processamento interno!</>
                                }
                            </>
                    }
                    </>
                :
                    <></>
            }
        </>
    );
};

export default Action5;